import '../styles/PastMatches.css';
import '../styles/App.css';
import Match from './Match.jsx';
import React, { useState } from 'react';

// Component for past matches -section

const PastMatches = ({ matches, setMatchData, loading }) => {
    const isMobile = window.innerWidth <= 768;

    const [showAllOldMatches, setShowAllOldMatches] = useState(false);

    const pastMatchesEmptyUnderWeek = matches.filter( (match) => (new Date(match.matchInfo.eventDate) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) 
                                                        && (new Date(match.matchInfo.eventDate) < new Date(Date.now()))).length === 0

    const pastMatchesEmptyOverWeek = matches.filter( (match) => (new Date(match.matchInfo.eventDate) < new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))).length === 0

    const overWeekOldMatches = matches.filter( (match) => (new Date(match.matchInfo.eventDate) < new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)))

    const visibleOldMatches = showAllOldMatches
            ? overWeekOldMatches
            : [...overWeekOldMatches]
                    .sort((a, b) => new Date(b.matchInfo.eventDate) - new Date(a.matchInfo.eventDate))
                    .slice(0, 5);


    function countDistinctEventIds(matches) {
        const eventIdSet = new Set();
        matches.forEach((match) => {
            if (match.eventId) {
            eventIdSet.add(match.eventId);
            }
        });
        return eventIdSet.size;
    }

    
    const handleToggleMatches = () => {
        const currentScrollY = window.scrollY;
        setShowAllOldMatches(!showAllOldMatches);
        setTimeout(() => {
            window.scrollTo({ top: currentScrollY, behavior: 'instant' });
        }, 0);
    };


    return(

        <div className="past-matches">
            <h2>MENNEET OTTELUT</h2>

            <p>Alla näet viikon sisällä pelatut ottelut. Näiden otteluiden lipun käyttäjien sähköpostiosoitteisiin voi vielä tehdä muutoksia.</p>
            
            <p 
                style={{
                    display: pastMatchesEmptyUnderWeek ? 'inline-block' : 'none',
                    alignItems: 'center',
                    fontSize: '17px',
                    fontFamily: 'Finlandica-Regular',
                    color: '#FFFFFF',
                    borderRadius: '10px',
                    backgroundColor: '#A99B70',
                    padding: '15px',
                    margin: '1vw 5vw 5vw 5vw',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                {loading
                    ? 'Ladataan...'
                    : 'Ei lippuja viikon sisällä pelattuihin otteluihin'
                }
            </p>

            <div className="matches-list-under-week-since-played">
                {(matches || [])
                    .filter( (match) => (new Date(match.matchInfo.eventDate) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) 
                                        && (new Date(match.matchInfo.eventDate) < new Date(Date.now())))
                    .sort((a, b) => new Date(b.matchInfo.eventDate) - new Date(a.matchInfo.eventDate))
                    .map((match) => (
                                    <Match
                                        key={match.eventId}
                                        eventId={match.eventId}
                                        matchInfo={match.matchInfo}
                                        tickets={match.tickets}
                                        setMatchData={setMatchData}
                                    />
                        )
                        )
                }
            </div>

            <p>Alla näet ottelut, jotka on pelattu <strong>yli</strong> viikko sitten. Näiden otteluiden lipun käyttäjien sähköpostiosoitteisiin ei voi enää tehdä muutoksia.</p>

            <p 
                style={{
                    display: pastMatchesEmptyOverWeek ? 'inline-block' : 'none',
                    alignItems: 'center',
                    fontSize: '17px',
                    fontFamily: 'Finlandica-Regular',
                    color: '#FFFFFF',
                    borderRadius: '10px',
                    backgroundColor: '#A99B70',
                    padding: '15px',
                    margin: '1vw 5vw 5vw 5vw',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                {loading
                    ? 'Ladataan...'
                    : 'Ei lippuja yli viikko sitten pelattuihin otteluihin'
                }
            </p>

            <div className="matches-list-over-week-since-played">
                {(visibleOldMatches || [])
                    .sort((a, b) => new Date(b.matchInfo.eventDate) - new Date(a.matchInfo.eventDate))
                    .map((match) => (
                                    <Match
                                        key={match.eventId}
                                        eventId={match.eventId}
                                        matchInfo={match.matchInfo}
                                        tickets={match.tickets}
                                        setMatchData={setMatchData}
                                    />
                        )
                        )
                }
            </div>
            {countDistinctEventIds(overWeekOldMatches) > 5 && (
                <button
                    onClick={handleToggleMatches}
                    style={{
                        alignItems: 'center',
                        fontSize: '22px',
                        fontFamily: 'Finlandica-Regular',
                        fontWeight: '600',
                        color: '#FFFFFF',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        backgroundColor: "transparent",
                        border: 'none',
                        paddingBottom: isMobile ? '50px' : '0'
                    }}
                >
                    {showAllOldMatches ? 'Näytä vähemmän' : 'Näytä enemmän'}
                </button>
            )}

        </div>
    )
};

export default PastMatches;